// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./libs/kendoUI/style/kendo.default.min.css
// module id = 747
// module chunks = 1